import { FC, ReactNode } from 'react';

import { cn } from '@/utils/tailwind.ts';

import { Card, CardContent } from '../../atoms/Card/Card';

type BannerProps = {
  title: string;
  description: string;
  rightButton: ReactNode;
  bottomButton?: ReactNode;
  variant?: 'neutral' | 'primary';
  className?: string;
};

export const Banner: FC<BannerProps> = ({
  title,
  description,
  rightButton,
  bottomButton,
  variant = 'neutral',
  className,
}) => {
  return (
    <Card
      className={cn(
        'rounded-none',
        variant === 'neutral' ? 'bg-custom-warm-grey-100' : 'bg-custom-cyan-50',
        className
      )}
    >
      <CardContent className="flex flex-col sm:flex-row sm:items-center justify-between gap-8">
        <div className="max-w-[550px]">
          <p className="text-body-16-semibold text-custom-cyan-500 mb-2">{title}</p>
          <p className="text-body-14-regular text-custom-warm-grey-500">{description}</p>
          {bottomButton && <div className="mt-4">{bottomButton}</div>}
        </div>
        <div>{rightButton}</div>
      </CardContent>
    </Card>
  );
};
